exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1sZ1SqOm-index-module-sidebar{border:1px solid #ced4da;bottom:0;left:0;padding:48px 5px 5px 15px;position:fixed;top:0;z-index:100}._363yBMQI-index-module-sidebar-sticky{height:calc(100vh - 48px);overflow-x:hidden;overflow-y:auto;padding-top:40px;position:-webkit-sticky;position:sticky;top:0}", ""]);

// exports
exports.locals = {
	"sidebar": "_1sZ1SqOm-index-module-sidebar",
	"sidebar-sticky": "_363yBMQI-index-module-sidebar-sticky",
	"sidebarSticky": "_363yBMQI-index-module-sidebar-sticky"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/support/layout/Sidebar/Sidebar/index.module.scss
// module id = 1211
// module chunks = 0